import { render, staticRenderFns } from "./todito.vue?vue&type=template&id=0f4f1d3e&"
import script from "./todito.vue?vue&type=script&lang=js&"
export * from "./todito.vue?vue&type=script&lang=js&"
import style0 from "./todito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopScreen: require('/builds/pagsmile/front-end/pagsmile-web/components/TopScreen.vue').default,FooterTop: require('/builds/pagsmile/front-end/pagsmile-web/components/footer/footerTop.vue').default})
